import script from "./orders.vue?vue&type=script&setup=true&lang=js"
export * from "./orders.vue?vue&type=script&setup=true&lang=js"

import "./orders.vue?vue&type=style&index=0&id=de13bd36&lang=less"

const __exports__ = script;

export default __exports__